/**
 * Pagination Component
 *
 * Generic pagination controls with prev/next buttons and page info.
 */

import { Component, Show } from "solid-js";
import styles from "./Pagination.module.css";

export interface PaginationInfo {
  page: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface PaginationProps {
  /** Current pagination state */
  pagination: PaginationInfo;
  /** Callback when previous page is clicked */
  onPrevious: () => void;
  /** Callback when next page is clicked */
  onNext: () => void;
  /** Label for previous button */
  prevLabel?: string;
  /** Label for next button */
  nextLabel?: string;
}

const Pagination: Component<PaginationProps> = (props) => {
  const prevLabel = () => props.prevLabel ?? "Zurück";
  const nextLabel = () => props.nextLabel ?? "Weiter";

  return (
    <Show when={props.pagination.totalPages > 1}>
      <div class={styles.pagination}>
        <button
          class={styles.paginationButton}
          disabled={!props.pagination.hasPrevPage}
          onClick={props.onPrevious}
        >
          {prevLabel()}
        </button>
        <span class={styles.paginationInfo}>
          Seite {props.pagination.page} von {props.pagination.totalPages}
        </span>
        <button
          class={styles.paginationButton}
          disabled={!props.pagination.hasNextPage}
          onClick={props.onNext}
        >
          {nextLabel()}
        </button>
      </div>
    </Show>
  );
};

export default Pagination;
